import React from 'react';
import Icon from '../../../components/AppIcon';

const HazardAnalyticsTable = ({ data }) => {
  const getSeverityColor = (severity) => {
    switch (severity?.toLowerCase()) {
      case 'critical':
        return 'text-error bg-error/10';
      case 'high':
        return 'text-warning bg-warning/10';
      case 'medium':
        return 'text-accent bg-accent/10';
      case 'low':
        return 'text-success bg-success/10';
      default:
        return 'text-muted-foreground bg-muted';
    }
  };

  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="border-b border-border">
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Hazard Type</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Occurrences</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Severity</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Incidents</th>
            <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Trend</th>
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => (
            <tr key={index} className="border-b border-border hover:bg-muted/50 transition-colors">
              <td className="py-3 px-4">
                <div className="flex items-center gap-2">
                  <Icon name={item?.icon} size={18} color="var(--color-muted-foreground)" />
                  <span className="text-sm font-medium text-foreground">{item?.type}</span>
                </div>
              </td>
              <td className="py-3 px-4 text-sm text-foreground">{item?.occurrences}</td>
              <td className="py-3 px-4">
                <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getSeverityColor(item?.severity)}`}>
                  {item?.severity}
                </span>
              </td>
              <td className="py-3 px-4 text-sm text-foreground">{item?.incidents}</td>
              <td className="py-3 px-4">
                <div className={`flex items-center gap-1 text-sm font-medium ${item?.trendDirection === 'up' ? 'text-error' : 'text-success'}`}>
                  <Icon name={item?.trendDirection === 'up' ? 'TrendingUp' : 'TrendingDown'} size={16} />
                  <span>{item?.trendValue}</span>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default HazardAnalyticsTable;